import { orchestrator } from 'satcheljs';
import getPersonalBookingPageSettings from '../services/getPersonalSchedulingPage';
import getBookingPageSetupStatus from '../actions/getBookingPageSetupStatus';
import setBookingPageSetupStatus from '../actions/setBookingPageSetupStatus';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * get personal bookings info and sets whether the user has setup personal bookings already in the store
 */
export default orchestrator(getBookingPageSetupStatus, async () => {
    if (isFeatureEnabled('eventify-booking-calendar-button')) {
        const personalBookingInfo = await getPersonalBookingPageSettings();
        // if null, we want the default to say "Manage Personal Bookings"
        personalBookingInfo == null
            ? setBookingPageSetupStatus(true)
            : setBookingPageSetupStatus(personalBookingInfo?.IsAnonymousSharingAllowed);
    }
});
